import React, { Component } from 'react';
import { Modal,
    Alert,
    FormGroup,
    ControlLabel,
    FormControl,
    OverlayTrigger,
    Tooltip,
    Popover,
    Button,
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import Validation from 'react-validation';

// To handle requests
import AccountsAPI from '../utils/AccountsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

class SetAccountQuotaComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            modalErrorAlert: '',
            quota: '',
            success: false,
            showDeleteQuotaModal: false,
            deletionErrorAlert: '',
            deletionSuccess: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openDelConfirmation = this.openDelConfirmation.bind(this);
        this.closeDelConfirmation = this.closeDelConfirmation.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitQuota = this.submitQuota.bind(this);
        this.submitDeleteQuota = this.submitDeleteQuota.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            modalErrorAlert: '',
            quota: '',
            success: false,
            showDeleteQuotaModal: false,
            deletionErrorAlert: '',
            deletionSuccess: false,
        });
    }

    // Open quota deletion confirmation modal
    openDelConfirmation() {
        this.setState({ showDeleteQuotaModal: true });
    }

    // Close quota deletion confirmation modal
    closeDelConfirmation() {
        this.setState({
            showDeleteQuotaModal: false,
            deletionErrorAlert: '',
            deletionSuccess: false,
        });
    }

    // Handle text input change to update state
    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    // Fired when form is submitted
    submitQuota(e) {
        e.preventDefault();
        this.setState({ modalErrorAlert: '' });

        AccountsAPI.setQuotaForAccount(
          this.props.username,
          this.state.quota).then(() => {
              this.setState({
                  quota: '',
                  success: true,
              });
              if (this.props.callback) {
                  // Small timeout so the user can see the success message
                  setTimeout(() => {
                      this.props.callback();
                  }, 1500);
              }
          }).catch(message => {
              if (message.status === 401 || message.status === 403) {
                  window.location.href =
                    `${namespace}/login/error/${message.status}`;
              } else if (message.status === 400) {
                  this.setState({
                      modalErrorAlert: `Unable to set account quota.
                                Please verify that the quota is valid.`,
                  });
              } else {
                  this.setState({
                      modalErrorAlert: `Unable to process the request as the
                                       server returned an Internal Error.`,
                  });
              }
          }
        );
    }

    submitDeleteQuota(e) {
        e.preventDefault();
        this.setState({ deletionErrorAlert: '' });
        AccountsAPI.deleteQuotaForAccount(
          this.props.username).then(() => {
              this.setState({
                  deletionSuccess: true,
              });
              if (this.props.callback) {
                  // Small timeout so the user can see the success message
                  setTimeout(() => {
                      this.props.callback();
                  }, 1500);
              }
          }).catch(message => {
              if (message.status === 401 || message.status === 403) {
                  window.location.href =
                    `${namespace}/login/error/${message.status}`;
              } else if (message.status === 400) {
                  this.setState({
                      deletionErrorAlert: `Unable to delete account quota.
                                Please verify that a quota exists for this
                                account.`,
                  });
              } else {
                  this.setState({
                      deletionErrorAlert: `Unable to process the request as the
                                       server returned an Internal Error.`,
                  });
              }
          }
        );
    }

    quotaValidator(specQuota) {
        const quota = specQuota || this.state.quota;
        if (!quota.length) {
            return false;
        }
        const floatValue = parseFloat(quota);
        return (!Number.isNaN(floatValue) && floatValue > 0 &&
        floatValue.toString() === quota.toString());
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const successAlert = <Alert bsStyle="success">
          <strong>Success</strong>
          <br />
          Quota has been set
        </Alert>;

        let errorDeletionAlert = null;

        if (this.state.deletionErrorAlert.length) {
            errorDeletionAlert = <Alert bsStyle="danger">
                        {this.state.deletionErrorAlert}
                      </Alert>;
        }

        const successDeletionAlert = <Alert bsStyle="success">
          <strong>Success</strong>
          <br />
          Quota has been deleted
        </Alert>;

        const helpPopover = (
            <Popover id="popover-help-username" title="Account quota">
                {'The account space usage can be restricted using a quota. ' }
                {'The quota must be a positive number of gibibytes (GiB). '}
                {'A quota of 200 will limit the account disk usage to 200 '}
                {'GiB. '}
            </Popover>
        );

        const helpIcon = (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={helpPopover}>
                    <i className="fa fa-question-circle-o"></i>
            </OverlayTrigger>
        );

        let deleteConfirmationModal = null;

        if (this.state.showDeleteQuotaModal) {
            deleteConfirmationModal = (
              <Modal
                show={this.state.showDeleteQuotaModal}
                onHide={this.closeDelConfirmation}>
                  <Modal.Header
                    style={brandingStyles.backgrounds.panelHeader}
                  >
                      <Modal.Title
                        style={brandingStyles.backgrounds.panelHeader}
                      >
                          <i
                            className="fa fa-tasks"
                            style={brandingStyles.mainColor}
                          ></i>
                          <span>&nbsp;</span>
                          {'Delete account quota'}
                          <i
                              className="fa fa-times pull-right clickable"
                              style={Object.assign(
                                { marginTop: '3px' },
                                brandingStyles.mainColor
                              )}
                              onClick={this.closeDelConfirmation}
                          ></i>
                      </Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={brandingStyles.backgrounds.panel}>
                      {this.state.deletionSuccess ?
                        successDeletionAlert :
                        (<p>Are you sure you want to delete the quota for this
                      account?</p>)}
                      {errorDeletionAlert}
                  </Modal.Body>
                  <Modal.Footer
                      style={brandingStyles.backgrounds.panel}
                  >
                      <button
                        className={'btn btn-primary'}
                        style={brandingStyles.buttons.primary}
                        onClick={ this.submitDeleteQuota }>
                        Proceed
                      </button>
                      <button
                        className="btn btn-primary"
                        style={brandingStyles.buttons.primary}
                        onClick={ this.closeDelConfirmation }>
                        Cancel
                      </button>
                  </Modal.Footer>
              </Modal>
            );
        }

        const form = (
          <div>
            <Validation.components.Form>

                <div className="form-group">
                  <FormGroup
                    controlId="formValidationError2"
                    validationState={
                      this.state.quota.length > 0 &&
                      (this.quotaValidator()
                      ? null : 'error') || null
                    }>
                    <ControlLabel>
                      <i
                        className="fa fa-tasks"
                        style={brandingStyles.mainColor}
                      />
                    &nbsp;Account quota {helpIcon}
                    </ControlLabel>
                    <Validation.components.Input
                        className="form-control"
                        style={brandingStyles.backgrounds.input}
                        type="text"
                        value={this.state.quota}
                        onChange={this.handleChange}
                        placeholder="Account quota (GiB)"
                        name="quota"
                        validations={['required',
                            'validSetQuota',
                        ]}/>
                    <FormControl.Feedback />
                  </FormGroup>
                </div>
                {errorAlert}
                <Button
                  onClick={this.openDelConfirmation}
                  style={brandingStyles.buttons.primary}
                  className="btn btn-primary pull-left"
                >
                  Delete quota
                </Button>
                <Validation.components.Button
                  onClick={this.submitQuota}
                  style={brandingStyles.buttons.primary}
                  className="btn btn-primary pull-right"
                >
                  Submit
                </Validation.components.Button>

            </Validation.components.Form>
            <div style={{
                clear: 'both',
            }}></div>
          </div>
        );

        const buttonTooltip = (
          <Tooltip id="tooltip">
            {'Set account quota'}
          </Tooltip>
        );


        return (
          <OverlayTrigger
            placement="top"
            overlay={buttonTooltip}
          >
              <button
                className="btn btn-primary btn-xs set-quota-btn"
                style={brandingStyles.buttons.primary}
                onClick={this.openModal}>
                <i className="fa fa-tasks" />

                  <Modal show={this.state.showModal} onHide={this.closeModal}>
                      <Modal.Header
                        style={brandingStyles.backgrounds.panelHeader}
                      >
                          <Modal.Title
                            style={brandingStyles.backgrounds.panelHeader}
                          >
                              <i
                                className="fa fa-tasks"
                                style={brandingStyles.mainColor}
                              ></i>
                              <span>&nbsp;</span>
                              {'Set account quota'}
                              <i
                                  className="fa fa-times pull-right clickable"
                                  style={Object.assign(
                                    { marginTop: '3px' },
                                    brandingStyles.mainColor
                                  )}
                                  onClick={this.closeModal}
                              ></i>
                          </Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={brandingStyles.backgrounds.panel}>
                        {this.state.success ? successAlert : form}
                      </Modal.Body>
                  </Modal>
                  {deleteConfirmationModal}
              </button>
            </OverlayTrigger>
        );
    }

}

SetAccountQuotaComponent.propTypes = {
    username: PropTypes.string,
    callback: PropTypes.func,
};

export default SetAccountQuotaComponent;



/** WEBPACK FOOTER **
 ** ./src/components/SetAccountQuotaButton.js
 **/